import { ComponentType } from "react";
import { OrganizationDetails } from "./organization.model";

export enum ProductType {
    LANDLINE_TEXTING = 0,
    VOIP_TEXTING,
    MS_TEAMS_TEXTING,
    TOLL_FREE_TEXTING
}

export interface ProductModel {
    Type: ProductType;
    Label: string;
    Icon: string;
}

export interface RouteWizardStepModel {
    Label: string;
    Step: number;
    Component: ComponentType<any & RouteWizardStepModel & RouteWizardStepHandles>;
};

export interface RouteWizardStepHandles {
    NextHandler: (data?: any) => void;
    BackHandler: () => void;
};

export interface LandlineFormData {
    Name: string;
    PhoneNumber: string;
    Organization?: OrganizationDetails;
};

export interface PhoneNumberData{
    Name: string;
    PhoneNumber: string;
    Organization?: OrganizationDetails;
    SelectProduct:number;
    id:string,
    organizationId:string,
    number:string,
    status:any,
    plans:any[],
    message:string
    VerificationCount:number,
    CloseAllowed:boolean
}

export interface LandlineSubscriberFormData {
    AddressName?:string
    FirstName: string;
    LastName: string;
    HouseNumber: string;
    Address: string;
    ZipCode: string;
    City: string;
    State: string;
    Country: string;
    Organization?: OrganizationDetails;
};

export const mapToSubscriber = (data: any): LandlineSubscriberFormData => ({
    AddressName : data?.loaPersonName,
    Address: data?.streetName,
    City: data?.city,
    Country: data?.county,
    FirstName: data?.loaPersonName?.split(' ') ? data?.loaPersonName?.split(' ')[0] : "",
    HouseNumber: data?.houseNumber,
    LastName: data?.loaPersonName?.split(' ') && data?.loaPersonName?.split(' ').length > 1 ? data?.loaPersonName?.split(' ')[1] : "",
    State: data.stateCode,
    ZipCode: data.zip
})